import {
  getMomentDateTimeInXUnitsFromNow,
  getMomentDateTimeNow
} from "./utils"

const lastDeclinedNewCourseVersionKey = 'lastDeclinedNewCourseVersion'
const lastDeclinedNewMHECourseVersionKey = 'lastDeclinedNewMHECourseVersion'

export const getLastDeclinedNewCourseVersion = (): string | null => {
  return localStorage.getItem(lastDeclinedNewCourseVersionKey)
}

export const setLastDeclinedNewCourseVersion = (declinedNewCourseVersion: string): void => {
  localStorage.setItem(lastDeclinedNewCourseVersionKey, declinedNewCourseVersion)
}

export const clearLastDeclinedNewCourseVersion = (): void => {
  localStorage.removeItem(lastDeclinedNewCourseVersionKey)
}

export const getLastDeclinedNewMHECourseVersion = (): string | null => {
  return localStorage.getItem(lastDeclinedNewMHECourseVersionKey)
}

export const setLastDeclinedNewMHECourseVersion = (declinedNewCourseVersion: string): void => {
  localStorage.setItem(lastDeclinedNewMHECourseVersionKey, declinedNewCourseVersion)
}

export const clearLastDeclinedNewMHECourseVersion = (): void => {
  localStorage.removeItem(lastDeclinedNewMHECourseVersionKey)
}

const appUpsellBottomSheetKey = 'seenAppUpsellBottomSheetWithin24Hours'

export const setSeenAppUpsellBottomSheet = (): void => {
  const expireTimestamp = getMomentDateTimeInXUnitsFromNow(24, 'hours')
  localStorage.setItem(appUpsellBottomSheetKey, expireTimestamp)
}

export const clearSeenAppUpsellBottomSheet = (): void => {
  localStorage.removeItem(appUpsellBottomSheetKey)
}

export const getSeenAppUpsellBottomSheet = (): boolean => {
  const expireTimestamp = localStorage.getItem(appUpsellBottomSheetKey)
  if (!expireTimestamp) {
    return false
  }

  // compare the expiration time with the current time
  const now = getMomentDateTimeNow()
  if (now > expireTimestamp) {
    // if expired, delete the item from storage and return false
    clearSeenAppUpsellBottomSheet()
    return false
  }
  return true
}
